import { media } from 'styled-bootstrap-grid';
import styled from 'styled-components';

export const FormBox = styled.div`
  padding: 21px 26px;
  ${media.md`
    border: 1px solid #efefef;
    border-radius: 3px;
    margin-bottom: 20px;
`};
`;

export const Section = styled.div`
  padding-bottom: 200px;
`;

export const ReturnMessage = styled.p`
  margin-bottom: 0;
  font-size: 13px;
  padding-top: 5px;
`;

export const AdditionNotesWrapper = styled.div`
  padding: 0 26px;
  ${media.md`
    padding: 0 0;
  `}
`;

export const FieldSpacer = styled.div`
  margin-top: 20px;
`;

export const FlexContainer = styled.div`
  font-size: 14px;
  display: flex;
  flex-direction: row;
  gap: 1rem;
`;

export const DepositAmount = styled.p`
  display: inline;
  font-weight: 800;
  font-size: unset;
`;

export const DepositDescription = styled.p`
  display: inline;
`;

export const AdditionalInfoWrapper = styled.div`
  margin-top: 1rem;
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;
